import { render, staticRenderFns } from "./PruningCatching.vue?vue&type=template&id=19c454b6&scoped=true"
import script from "./PruningCatching.vue?vue&type=script&lang=js"
export * from "./PruningCatching.vue?vue&type=script&lang=js"
import style0 from "./PruningCatching.vue?vue&type=style&index=0&id=19c454b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c454b6",
  null
  
)

export default component.exports